import React, { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { RootState } from '../reducers';
import { fetchPatientProfileData, UploadImageData } from '../reduxactions/patientactions/PatientProfileActions';
import { PATIENT_API } from '../ApiNames';
import { LoginService } from '../services/LoginService';
import { FileUpload, FileUploadHandlerEvent } from 'primereact/fileupload';
import { getCountry, getcountryname, getState } from '../reduxactions/doctoractions/DoctorProfileActions';
import useEffectOnce from '../hooks/useEffectOnce';
import { Dropdown, DropdownChangeEvent } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { Panel } from 'primereact/panel';
import { Button } from 'primereact/button';
import { Card } from 'primereact/card';
import { useNavigate } from 'react-router-dom';
import { Toast } from 'primereact/toast';
import eventBus from '../doctorapprover/eventBus';

export const PatientProfile = () => {
    const uid = window.sessionStorage.getItem('uid');

    const [globalFilter, setGlobalFilter] = useState('');
    const stepperRef = useRef(null);
    const dispatch = useDispatch();
    const data = useSelector((state: RootState) => state.patientprofile.data);
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastname] = useState('');
    const [email, setEmail] = useState('');
    const [idcard, setIdCard] = useState('');
    const [dob, setDateOfBirth] = useState('');
    const [gender, setGender] = useState('');
    const [phone, setPhone] = useState('');
    const [contactname, setContactname] = useState('');
    const [ContactNumber, setContactNumber] = useState('');
    const [fax, setFax] = useState('');
    const [Speciality, setSpeciality] = useState('');
    const [country, setCountry] = useState('');
    const [state, setState] = useState('');
    const [city, setCity] = useState('');
    const [street, setStreet] = useState('');
    const [dno, setDNO] = useState('');
    const [zip, setZip] = useState('');
    const [mob, setMob] = useState('');
    const [skype, setSkype] = useState('');
    const [paypal, setPayPal] = useState('');
    const [photo, setPhoto] = useState('');
    const [profileImage1, setProfileImage1] = useState('');
    console.log('UpdatedPic', profileImage1)
    // useEffect(() => {
    //     const profilephoto = data[0]?.photo;
    //     window.sessionStorage.setItem('photo', profilephoto);
    //     handlePhotoUpdate(profilephoto);
    // }, [data]);
    useEffect(() => {
        const profilephoto = profileImage1;
        window.sessionStorage.setItem('photo', profilephoto);
        handlePhotoUpdate(profilephoto);
    }, [profileImage1]);

    const handlePhotoUpdate = (newPhoto: any) => {
        setPhoto(newPhoto);
        eventBus.emit('photoUpdated', newPhoto);
    };
    const fetchDataAsync = async () => {
        try {
            await dispatch(fetchPatientProfileData(uid) as any);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    useEffect(() => {
        fetchDataAsync();
    }, [dispatch]);
    const [selectedFile, setselectedFile] = useState<File | null>(null);
    const fileUploadRef = useRef<FileUpload>(null)
    const UploadManagerImage = async (event: FileUploadHandlerEvent) => {
        const files = event.files;
        if (files.length > 0) {
            const file = files[0];
            console.log("file:", file);
            setselectedFile(file);
            console.log("called image function:", file)
            try {
                await dispatch(UploadImageData(file, uid) as any);
                fetchDataAsyncData();
                if (fileUploadRef.current) {
                    fileUploadRef.current.clear();
                }
                setselectedFile(null);
            } catch (error) {
                console.error('Error uploading image:', error);
            }
        }

    };
    //To get data
    const fetchDataAsyncData = async () => {
        try {
            const payload = { uid: uid };
            const apiname = PATIENT_API.patientprofile_API;
            const response = await LoginService.getData(apiname, payload);
            console.log('response', response)
            setFirstName(response[0].firstName);
            setLastname(response[0].lastName);
            setEmail(response[0].email);
            setIdCard(response[0].idcard);
            setDateOfBirth(response[0].dob);
            setGender(response[0].gender);
            setPhone(response[0].phone);
            setContactname(response[0].contactname);
            setContactNumber(response[0].contactph);

            setFax(response[0].fax);
            setSpeciality(response[0].specialty);
            setCountry(response[0].country);
            setState(response[0].state);
            setCity(response[0].city);
            setStreet(response[0].street);
            setDNO(response[0].dno);
            setZip(response[0].zip);
            setMob(response[0].mob);
            setSkype(response[0].skype);
            setPayPal(response[0].paypal);
            setProfileImage1(response[0].photo);
            const country = response[0].country;
            if (country && country.length > 0) {
                fetchstate(country);
                getcountryvalue(country);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    useEffectOnce(() => {
        fetchDataAsyncData();
    }, [dispatch]);
    const countrydata = useSelector((state: RootState) => state.doctorprofile.country);
    const statedata = useSelector((state: RootState) => state.doctorprofile.state);
    const name = useSelector((state: RootState) => state.doctorprofile.name);



    useEffectOnce(() => {
        const fetchcountry = async () => {
            try {
                await dispatch(getCountry() as any);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };
        fetchcountry();
    }, [dispatch]);
    const fetchstate = async (country: any) => {
        try {
            await dispatch(getState(country) as any);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const getcountryvalue = async (country: any) => {
        try {
            await dispatch(getcountryname(country) as any);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const genderoptions = [
        { label: 'Male', value: 'male' },
        { label: 'Female', value: 'female' },

    ];
    const navigate = useNavigate();
    const viewPage1 = () => {
        const url = `/patientuploads`;
        navigate(url);
    };
    const [isChecked, setIsChecked] = useState(false);
    const handleCheckboxChange = (e: any) => {
        setIsChecked(e.target.checked);
    };
    const toast = useRef<Toast>(null);
    //update
    const updateProfilePersonal = async () => {
        try {
            const payload = { city: city, contactname: contactname, contactph: ContactNumber, country: country, dno: dno, dob: dob, fax: fax, gender: gender, idcard: idcard, mob: mob, paypal: paypal, phone: phone, skype: skype, state: state, street: street, uid: uid, zip: zip }
            const apiname = PATIENT_API.update_API;
            const data = await LoginService.getData(apiname, payload);
            fetchDataAsyncData();
            if (toast.current) {
                toast.current.show({ severity: 'success', detail: data });
            }
        } catch (error) {
            console.error('Error fetching address data:', error);
        }
    };
    //apply funtion
    const ApplyProfileData = async () => {
        try {
            const payload = { city: city, contactname: contactname, contactph: ContactNumber, country: country, dno: dno, dob: dob, fax: fax, gender: gender, idcard: idcard, mob: mob, paypal: paypal, phone: phone, skype: skype, state: state, street: street, uid: uid, zip: zip }
            const apiname = PATIENT_API.applyprofile_API;
            const data = await LoginService.getData(apiname, payload);
            fetchDataAsyncData();
        } catch (error) {
            console.error('Error fetching address data:', error);
        }
    };
    //validations 
    const phoneError = {
        required: (phone || '').trim() === '',
        invalid: !/^\d{10}$/.test((phone || '').trim()) && (phone || '').trim() !== '',
    };

    const phoneError1 = {
        required: (ContactNumber || '').trim() === '',
        invalid: !/^\d{10}$/.test((ContactNumber || '').trim()) && (ContactNumber || '').trim() !== '',
    };

    const zipError = {
        required: (zip || '').trim() === '',
        invalid: !/^\d{6}$/.test((zip || '').trim()) && (zip || '').trim() !== '',
    };

    const streetError = {
        required: (street || '').trim() === '',
        invalid: !/^[A-Za-z0-9\s]+$/.test((street || '').trim()) && (street || '').trim() !== '',
    };

    const cityError = {
        required: (city || '').trim() === '',
        invalid: !/^[A-Za-z\s]+$/.test((city || '').trim()) && (city || '').trim() !== '',
    };

    const nameError = {
        required: (contactname || '').trim() === '',
        invalid: !/^[a-zA-Z\s]*$/.test((contactname || '').trim()) && (contactname || '').trim() !== '',
    };

    const errorStyle = {
        color: 'white',
        fontWeight: '400',
        backgroundColor: '#dc3545',
        height: '35px',
        alignItems: 'center',
        width: '380px',
        padding: '8px 10px',
        marginTop: '0px',
        marginLeft: '-10px',
    }
    //for help
    const [openHelp, setHelp] = useState(false);
    const url1 = window.sessionStorage.getItem("apiRoot");
    const IUrl = `${url1}/help/patientprofile.php`;
    const helpImg = `${url1}/help/help3.png`;
    const openWindow = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, targetUrl: string): void => {
        event.preventDefault();
        const newWindowReference = window.open(
            targetUrl,
            'newwindow',
            'width=1000,height=1000,noopener,noreferrer'
        );

        if (newWindowReference) {
            newWindowReference.opener = null;
        }
    };
    return (
        <div className="admin-layout-container">
            <div className="row">
                <div className="main-content">
                    <div className="col-16" style={{ textAlign: "right" }}>
                        <a
                            title="help"
                            onClick={(e) => openWindow(e, IUrl)}
                            style={{

                                color: "blue",
                                fontSize: 15, cursor: "pointer"
                            }}
                        >Help for this Page &nbsp;
                            <i style={{ marginTop: 40, backgroundColor: "orange", color: "white" }} className="pi pi-question-circle"></i>

                        </a>
                    </div>

                    <div className="content-wrapper">
                        <section className="content">
                            <div className="grid">
                                {data.map((response: any) =>
                                    <div className="col-3">
                                        <Panel
                                            header=""
                                            style={{
                                                width: '280px',
                                                borderTop: '3px solid #007bff',
                                                textAlign: 'center',
                                                borderRadius: '4px',
                                                marginTop: '70px'
                                            }}
                                        >
                                            <div>
                                                <img
                                                    src={profileImage1}
                                                    alt="User Avatar"
                                                    style={{
                                                        width: '120px',
                                                        height: '56px',
                                                        borderRadius: '50%',  // Circular image
                                                        border: '3.5px solid #adb5bd',
                                                    }}
                                                />
                                            </div>

                                            <h3
                                                className="widget-user-username"
                                                style={{
                                                    color: 'black',
                                                    fontSize: '25px',
                                                    fontWeight: '300',
                                                    marginBottom: '20px',
                                                    marginTop: '20px'  // Proper spacing after the image
                                                }}
                                            >
                                                {response.firstName}
                                            </h3>

                                            <h2
                                                className="widget-user-username"
                                                style={{
                                                    color: '#6c757d',
                                                    fontSize: '20px',
                                                    fontWeight: '300',
                                                    marginBottom: '20px',
                                                }}
                                            >
                                                Patient
                                            </h2>

                                            <FileUpload
                                                ref={fileUploadRef}
                                                mode="basic"
                                                id="fileToUpload"
                                                name="fileToUpload"
                                                customUpload
                                                accept="image/*"
                                                maxFileSize={1000000}
                                                uploadHandler={UploadManagerImage}
                                                auto
                                            />
                                            {selectedFile && <p style={{ marginTop: '10px' }}>{selectedFile.name}</p>}
                                        </Panel>




                                    </div>
                                )}
                                <div className='col-6' style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                    <div className='col-12' >
                                    </div>
                                </div >
                                <div className='col-3' >
                                    <div style={{ marginTop: '40px', marginLeft: '-600px' }}>
                                        <div className='col-2'></div>
                                        <div className='col-2'></div>
                                        <div>
                                            <Panel header="Profile" className="profile-header" style={{ width: '900px' }} toggleable>

                                                <Card
                                                    header={
                                                        <div style={{ width: '100%' }}>
                                                            <h1 style={{ margin: 0, float: 'left', marginBottom: '30px', width: '100%' }}>
                                                                PATIENT (*{data[0]?.status}*)
                                                            </h1>
                                                        </div>
                                                    }>
                                                    <div className='grid'>
                                                        <div className="col-6">
                                                            <div className="col-3" style={{ display: 'flex', flex: 1, width: '200px' }}>
                                                                <label htmlFor="fname" className="block text-900 font-medium ">First Name</label>
                                                            </div>
                                                            <div className="col-12">
                                                                <InputText id="phone" type="text" placeholder="Enter Firstname" value={firstName} onChange={(e) => setFirstName(e.target.value)} className="w-full mb-3" disabled />
                                                            </div>
                                                            <div className="col-3" style={{ display: 'flex', flex: 1, width: '200px' }}>
                                                                <label htmlFor="lname" className="block text-900 font-medium">Last Name</label>
                                                            </div>
                                                            <div className="col-12">
                                                                <InputText id="phone" type="text" placeholder="Enter LastName" value={lastName} onChange={(e) => setLastname(e.target.value)} className="w-full mb-3" disabled />
                                                            </div>
                                                            <div className="col-3" style={{ display: 'flex', flex: 1, width: '200px' }}>
                                                                <label htmlFor="email" className="block text-900 font-medium ">E-mail</label>
                                                            </div>
                                                            <div className="col-12">
                                                                <InputText id="phone" type="text" placeholder="Enter Email" value={email} onChange={(e) => setEmail(e.target.value)} className="w-full mb-3" disabled />
                                                            </div>
                                                            <div className="col-5" style={{ display: 'flex', flex: 1, width: '200px' }}>
                                                                <label htmlFor="email" className="block text-900 font-medium ">ID Card</label>

                                                            </div>
                                                            <div className="col-12">
                                                                <InputText id="idcard" type="number" placeholder="Enter IDCard" value={idcard} onChange={(e) => setIdCard(e.target.value)} className="w-full mb-3" />
                                                            </div>


                                                            <div className="col-3" style={{ display: 'flex', flex: 1, width: '200px' }}>
                                                                <label htmlFor="phone" className="block text-900 font-medium ">DateOfBirth</label>
                                                            </div>
                                                            <div className="col-12">
                                                                <InputText id="phone" type="date" placeholder="Enter DateOfBirth" value={dob} onChange={(e) => setDateOfBirth(e.target.value)} className="w-full mb-3" />
                                                            </div>

                                                            <div className="col-3" style={{ display: 'flex', flex: 1, width: '200px' }}>
                                                                <label htmlFor="gender" className="block text-900 font-medium ">Gender</label>
                                                            </div>
                                                            <div className="col-12">
                                                                <Dropdown id="gender" value={gender} className="w-full mb-3" onChange={(e: DropdownChangeEvent) => setGender(e.value)} options={genderoptions} optionLabel="label" optionValue="value" placeholder="Select a Gender" style={{ textAlign: 'left' }} />
                                                            </div>
                                                            <div className="col-3" style={{ display: 'flex', flex: 1, width: '200px' }}>
                                                                <label htmlFor="cardno" className="block text-900 font-medium ">Phone Number </label>
                                                            </div>
                                                            <div className="col-12">
                                                                <InputText type="number" name="pincode" placeholder="Enter Phone Number" maxLength={10} className="w-full mb-3" value={phone} onChange={(e) => { const value = e.target.value; if (/^\d{0,10}$/.test(value)) { setPhone(value); } }} />
                                                                {phoneError.invalid && (
                                                                    <div style={errorStyle}>
                                                                        Invalid phone number: Must be exactly 10 digits
                                                                    </div>
                                                                )}
                                                            </div>
                                                            <div className="col-3" style={{ display: 'flex', flex: 1, width: '300px' }}>
                                                                <label htmlFor="cardno" className="block text-900 font-medium "> Emergency Contact Name * </label>
                                                            </div>
                                                            <div className="col-12">
                                                                <InputText id="phone" type="text" placeholder="Enter Contact Name " value={contactname} onChange={(e) => setContactname(e.target.value)} className="w-full mb-3" />
                                                                {nameError.invalid && (
                                                                    <div style={errorStyle}>
                                                                        Contact name is required
                                                                    </div>
                                                                )}
                                                            </div>
                                                            <div className="col-3" style={{ display: 'flex', flex: 1, width: '300px' }}>
                                                                <label htmlFor="cardno" className="block text-900 font-medium "> Emergency Contact Phone *</label>
                                                            </div>
                                                            <div className="col-12">
                                                                <InputText id="phone" type="number" placeholder="Enter Phone" value={ContactNumber} onChange={(e) => setContactNumber(e.target.value)} className="w-full mb-3" />
                                                                {phoneError1.invalid && (
                                                                    <div style={errorStyle}>
                                                                        Invalid phone number: Must be exactly 10 digits
                                                                    </div>
                                                                )}
                                                            </div>


                                                        </div>
                                                        <div className="col-6">
                                                            <div className="col-4" style={{ display: 'flex', flex: 1, width: '200px' }}>
                                                                <label htmlFor="cardno" className="block text-900 font-medium ">Country </label>
                                                            </div>
                                                            <div className="col-12">
                                                                <Dropdown id="country" value={country} className="w-full mb-3 custom-dropdown" onChange={(e: DropdownChangeEvent) => { fetchstate(e.value); setCountry(e.value) }} options={countrydata} optionLabel="name" optionValue="id" placeholder="Select a Country" />
                                                            </div>
                                                            <div className="col-4" style={{ display: 'flex', flex: 1, width: '200px' }}>
                                                                <label htmlFor="cardno" className="block text-900 font-medium ">State </label>
                                                            </div>
                                                            <div className="col-12">
                                                                <Dropdown id="country" value={state} className="w-full mb-3 custom-dropdown" onChange={(e: DropdownChangeEvent) => setState(e.value)} options={statedata} optionLabel="name" optionValue="id" placeholder="Select a State" />
                                                            </div>
                                                            <div className="col-4" style={{ display: 'flex', flex: 1, width: '200px' }}>
                                                                <label htmlFor="cardno" className="block text-900 font-medium ">City </label>
                                                            </div>
                                                            <div className="col-12">
                                                                <InputText id="phone" placeholder="Enter City" value={city} onChange={(e) => setCity(e.target.value)} className="w-full mb-3" />
                                                                {cityError.required && (
                                                                    <div style={errorStyle}>City is required</div>
                                                                )}

                                                            </div>

                                                            <div className="col-4" style={{ display: 'flex', flex: 1, width: '200px' }}>
                                                                <label htmlFor="cardno" className="block text-900 font-medium ">Street </label>
                                                            </div>
                                                            <div className="col-12">
                                                                <InputText id="phone" placeholder="Enter Street" value={street} onChange={(e) => setStreet(e.target.value)} className="w-full mb-3" />
                                                                {streetError.required && (
                                                                    <div style={errorStyle}>Street is required</div>
                                                                )}

                                                            </div>
                                                            <div className="col-4" style={{ display: 'flex', flex: 1, width: '200px' }}>
                                                                <label htmlFor="cardno" className="block text-900 font-medium ">Door No </label>
                                                            </div>
                                                            <div className="col-12">
                                                                <InputText id="phone" placeholder="Enter Door Number" value={dno} onChange={(e) => setDNO(e.target.value)} className="w-full mb-3" />
                                                            </div>
                                                            <div className="col-4" style={{ display: 'flex', flex: 1, width: '200px' }}>
                                                                <label htmlFor="cardno" className="block text-900 font-medium ">Zip </label>
                                                            </div>
                                                            <div className="col-12">
                                                                <InputText id="phone" placeholder="Enter Zip" value={zip} onChange={(e) => setZip(e.target.value)} className="w-full mb-3" />
                                                                {zipError.required && (
                                                                    <div style={errorStyle}>ZIP code is required</div>
                                                                )}

                                                            </div>
                                                            <div className="col-4" style={{ display: 'flex', flex: 1, width: '220px' }}>
                                                                <label htmlFor="cardno" className="block text-900 font-medium "><i className="pi pi-whatsapp" style={{ color: 'green', fontSize: '30px' }}></i> Mobile (WhatsApp) * </label>
                                                            </div>
                                                            <div className="col-12">
                                                                <InputText id="phone" placeholder="Enter Mobile" value={mob} onChange={(e) => setMob(e.target.value)} className="w-full mb-3" />
                                                            </div>
                                                            <div className="col-4" style={{ display: 'flex', flex: 1, width: '200px' }}>
                                                                <label htmlFor="cardno" className="block text-900 font-medium "><i className="pi pi-pi-skype" style={{ color: 'blue', fontSize: '30px' }}></i> Skype ID * </label>
                                                            </div>
                                                            <div className="col-12">
                                                                <InputText id="phone" placeholder="Enter Skype" value={skype} onChange={(e) => setSkype(e.target.value)} className="w-full mb-3" />
                                                            </div>
                                                            <div className="col-4" style={{ display: 'flex', flex: 1, width: '200px' }}>
                                                                <label htmlFor="cardno" className="block text-900 font-medium "><i className="pi-pi-paypal" style={{ color: 'blue', fontSize: '30px' }}></i> PAYPAL Account * </label>
                                                            </div>
                                                            <div className="col-12">
                                                                <InputText id="phone" placeholder="Enter PayPal" value={paypal} onChange={(e) => setPayPal(e.target.value)} className="w-full mb-3" />
                                                            </div>
                                                            <div className="col-4" style={{ display: 'flex', flex: 1, width: '200px' }}>
                                                                <label htmlFor="cardno" className="block text-900 font-medium ">Fax Number </label>
                                                            </div>
                                                            <div className="col-12">
                                                                <InputText id="phone" placeholder="Enter Fax Number" value={fax} onChange={(e) => setFax(e.target.value)} className="w-full mb-3" />
                                                            </div>
                                                        </div>
                                                        <div className="col-12 card-footer">
                                                            <Button label="Update" className="p-button-primary" onClick={updateProfilePersonal} />
                                                            <Button label="Uploads" style={{ marginLeft: '35px' }} onClick={viewPage1} />
                                                        </div>
                                                    </div>

                                                </Card>
                                            </Panel>



                                        </div>
                                    </div>
                                </div>
                            </div>

                        </section>
                    </div>
                </div>
                {/* <Toast ref={toast} /> */}
                <Toast ref={toast} ></Toast>

            </div>
        </div>)
}
